import * as z from "zod/v4";

const trackstarReturnConnectionSettingsSchema_ = z.object({
  shouldLookupOrderNameFromTrackstar: z
    .object({ enabled: z.boolean().optional() })
    .optional(),
  shouldIncludeBundleProducts: z.boolean().optional(),
  allowBlindReturns: z.boolean().optional(),
  allowBlindReturnsFallback: z.boolean().optional(),
  disableIncludeTrackingNumber: z.boolean().optional(),
});
export const trackstarReturnConnectionSettingsSchema: z.ZodType<TrackstarReturnConnectionSettings> =
  trackstarReturnConnectionSettingsSchema_;
export interface TrackstarReturnConnectionSettings
  extends z.infer<typeof trackstarReturnConnectionSettingsSchema_> {}

export const trackstarConnectionsSchema = z.object({
  connectionId: z.string(),
  type: z.string(),
  settings: trackstarReturnConnectionSettingsSchema.optional(),
});
export const trackstarConnections = z.object({
  returnConnections: trackstarConnectionsSchema.array(),
  omsConnections: trackstarConnectionsSchema.array(),
});

export type TrackstarConnections = z.infer<typeof trackstarConnections>;
export const getTrackstarConnections = {
  name: "getTrackstarConnections" as const,
  input: z.object({}),
  output: z.object({ connections: trackstarConnections.nullable() }),
};
